import moment from "moment";
import parse from "html-react-parser";
import {Link, useParams} from "react-router-dom";
import {Disclosure} from "@headlessui/react";

import Blocks from "../blocks";

import GroupDiscussion from "../../assets/images/group-discussion.png";
import {getClassDetailsById} from "../../utils/reactQueries";

const PageClassInfo = () => {

    const params = useParams();
    const classId = params.classId;

    /** get class details */
    const {status, data: classData, error: classError, isFetching} = getClassDetailsById(classId);
    const _classData = classData?.data;

    return (
      <div className={"page PageClassInfo"}>
        <div className="container mx-auto">
          <h3
            className={
              "block lg:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"
            }
          >
            Create your class plan
          </h3>
          <div className="flex flex-col lg:flex-row items-center">
            <div className="bgWrapper lg:flex justify-center items-center bg-white">
              <img src={GroupDiscussion} alt="" />
            </div>
            <div className="pageContent w-full max-w-2xl mx-auto md:mr-0 md:ml-auto  mb-4 bg-white p-4 rounded-xl">
              <h1 className={"hidden lg:block text-4xl font-heading mb-10"}>
                Create your class plan
              </h1>
              <Blocks.ErrorBoundary>
                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="bg-white z-10">
                        <div className="shadow z-10 rounded-lg p-2 text-sm flex items-center">
                          <span className="grid grid-rows-2 lg:grid-cols-2 lg:grid-rows-1 flex-grow ">
                            <span className="grid grid-cols-2 text-sm mt-1">
                              <span className="mr-3  min-w-lg  text-sm md:text-lg flex items-center">
                                <i className="text-zinc-400 icon icon-user text-2xl mr-0.5 md:mr-3"></i>
                                <span className="text-sm">
                                  {_classData?.title}
                                </span>
                              </span>
                              <span className="mr-3 max-w-xs text-sm md:text-lg flex items-center">
                                <i className="text-zinc-400 icon icon-book-open text-2xl mr-0.5 md:mr-3"></i>
                                <p className="truncate text-sm">
                                  {_classData?.subject?.title}
                                </p>
                              </span>
                            </span>
                            <span className="grid grid-cols-1 mt-1">
                              <span className="mr-3 min-w-lg text-sm md:text-lg flex items-center">
                                <i className="text-zinc-400 icon icon-clock text-2xl mr-0.5 md:mr-3"></i>
                                <span className="text-sm">
                                  {moment
                                    .unix(_classData?.start_time)
                                    .format("HH:mmA")}
                                  -
                                  {moment
                                    .unix(
                                      _classData?.start_time +
                                        _classData?.duration_seconds
                                    )
                                    .format("HH:mmA")}
                                </span>
                              </span>
                            </span>
                          </span>
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="text-gray-500 bg-[#F4F4F4] rounded-lg">
                        <div className="px-3 py-1">
                          <div className="flex flex-row justify-between p-2">
                            <span className="text-md text-black">Details</span>
                            <span className="text-md ">
                              <button
                                type="button"
                                onClick={() => {
                                  history.push(
                                    `/create-virtual-class/${_classData.id}/edit`
                                  );
                                }}
                              >
                                <i className="icon icon-edit-2"></i>
                              </button>
                            </span>
                          </div>
                          {_classData?.description && (
                            <div className="p-2">
                              <div className="text-sm text-black text-left pl-2">
                                {parse(_classData.description)}
                              </div>
                            </div>
                          )}
                        </div>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>

                <div className="flex flex-col items-center my-10">
                  <Link
                    className="bg-black  hover:bg-slate-600 text-white font-bold py-2 px-8  rounded-lg focus:outline-none focus:shadow-outline flex justify-center items-center"
                    to={"./class-plan"}
                  >
                    Create plass plan
                  </Link>

                  <span className="px-4 py-2 text-sm text-center italic">
                    or
                  </span>

                  <Link
                    className="hover:text-slate-600 text-black py-2 px-8 focus:outline-none focus:shadow-outline underline italic"
                    to="./add-students"
                  >
                    Skip this and add students
                  </Link>
                </div>
              </Blocks.ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    );
};

export default PageClassInfo;
